import { Gift2 } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';

/**
 * Compact offer snippet shown within the registration flow header
 *
 * Behaviour:
 * - Reads `bundleCode` from the URL search params
 * - If `bundleCode` is missing, renders the fallback title and hides the gift icon
 * - If `bundleCode` exists, renders the normal title and shows the gift icon
 * - Does not perform any API calls; purely derives state from the URL
 */
function OfferCompact() {
  const t = useTranslations('register');
  const searchParams = useSearchParams();
  const bundleCode = searchParams.get('code') || '';
  const hasOffer = Boolean(bundleCode);
  const titleKey = hasOffer ? 'offer.compact.title' : 'offer.compact.titleFallback';

  return (
    <div className="justify-self-center flex min-width-0 items-center gap-2 whitespace-nowrap">
      {hasOffer ? <Gift2 size="extra-small" className="text-brand flex-[1_0_auto]" /> : null}
      <span className="paragraph-explanatory">{t(titleKey)}</span>
    </div>
  );
}

export { OfferCompact };
